import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import { BgImage } from "gbimage-bridge"
import styled from "styled-components"
import { FaAngleDoubleDown } from "react-icons/fa"

const Hero = () => {
  const { placeholderImage } = useStaticQuery(
    graphql`
      query {
        placeholderImage: file(relativePath: { eq: "landscape/krakatoa.jpg" }) {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
              layout: FIXED
              quality: 100
            )
          }
        }
      }
    `
  )
  const pluginImage = getImage(placeholderImage)

  return (
    <Wrapper>
      <BgImage
        image={pluginImage}
        css={`
          position: relative;
          left: 100%;
          transform: translateZ(-1px) scale(2);

          @media screen and (min-width: 600px) {
            left: 0;
          }
        `}
      />
      <Text>
        <h1>Giovanni Vitali</h1>
        <h2>photography</h2>
      </Text>
      <Nav>
        <NavItem to="/portfolio">View Portfolio</NavItem>
        <NavItem to="/portfolio#contact">Contact Me</NavItem>
      </Nav>
      <FaAngleDoubleDown
        css={`
          position: absolute;
          bottom: 1%;
          font-size: 2.25rem;
          width: 100%;
          display: flex;
          justify-content: center;
          animation: bounce 1s alternate infinite;

          @keyframes bounce {
            0% {
              transform: translateY(0);
            }
            100% {
              transform: translateY(-50px);
            }
          }
        `}
      />
    </Wrapper>
  )
}

export default Hero

const Wrapper = styled.div`
  height: 100vh;
`

const Text = styled.div`
  position: absolute;
  top: 20%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  letter-spacing: 15px;
  animation: logoEntrance 1s;

  h1,
  h2 {
    font-weight: normal;
  }

  h1 {
    font-size: clamp(4rem, 8vw, 6rem);
  }

  h2 {
    font-size: clamp(2rem, 6.5vw, 4rem);
  }

  @keyframes logoEntrance {
    from {
      opacity: 0;
      transform: translate3d(0, 200%, 0);
    }
  }

  @media screen and (max-width: 499px) {
    h1 {
      font-size: 3rem;
    }

    h2 {
      font-size: 1.25rem;
    }
  }
`

const Nav = styled.nav`
  position: absolute;
  top: 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  list-style-type: none;
  font-family: "lato";
  font-size: clamp(1.35rem, 3vw, 1.6rem);
  font-weight: 300;
  animation: navEntrance 1s;

  @keyframes navEntrance {
    from {
      opacity: 0;
      transform: translate3d(0, 150%, 0);
    }
  }

  @media screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
  }
`

const NavItem = styled(Link)`
  color: #fff;
  text-decoration: none;

  :first-child {
    margin-bottom: 5vh;
  }

  @media screen and (min-width: 768px) {
    :first-child {
      margin-bottom: 0;
      margin-right: 15vw;
    }
  }
`
